<template>
    <div>
        <div v-if="unreadCountForDisplayInChat > 0 && message.showUnread" ref="unreadBar" class="chat-conv-detail__messages__unread-bar">
            {{unreadCountForDisplayInChat}} UNREAD MESSAGE<template v-if="unreadCountForDisplayInChat > 1">S</template>
        </div>

        <div class="message w-75 mb-3" v-bind:class="{'ml-auto' : isHostMessage || isSystemMessage}">
            <div class="rounded py-2 px-3 mb-2" v-bind:class="{'message--host': isHostMessage, 'message--guest' : isGuestMessage, 'message--system' : isSystemMessage, 'message--failed' : isFailed}">
                <template v-if="hasMedia">
                    <div v-for="(media, index) in message.media" v-bind:key="index">
                        <template v-if="media.mediaType.startsWith('image')">
                            <img v-bind:src="media.mediaUrl" class="message__media message__media__image" />
                        </template>
                        <template v-if="media.mediaType.startsWith('video')">
                            <video controls class="message__media message__media__video">
                                <source v-bind:src="media.mediaUrl" type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        </template>
                        <template v-if="media.mediaType.startsWith('audio')">
                            <audio controls class="message__media message__media__audio">
                                <source v-bind:src="media.mediaUrl" type="audio/mpeg" />
                                Your browser does not support the audio element.
                            </audio>
                        </template>
                        <template v-if="media.mediaType === 'application/pdf'">
                            <a v-bind:href="media.mediaUrl" target="_blank" v-bind:download="getMediaFileName(media.mediaUrl) + '.pdf'" class="message__media message__media__file">
                                <i class="fa-solid fa-file-pdf"></i>
                                {{getMediaFileName(media.mediaUrl) + '.pdf'}}
                            </a>
                        </template>
                    </div>
                </template>

                <p class="text-small mb-0" v-html="formatChatContentForDisplay(message.content)"></p>

                <div v-if="hasActions">
                    <div v-for="(action, index) in message.actions" v-bind:key="index" class="message__footer">
                        <div class="message__footer--form-invite">
                            <a v-bind:href="action.url" target="_blank">
                                <i class="fa-solid fa-arrow-up-right-from-square"></i>
                                {{action.title}}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <p class="small text-muted text-right">
                {{friendlyChatTime(message.created)}}
                &nbsp;&nbsp;|&nbsp;&nbsp;
                {{friendlyChatDateShort(message.created)}}
                <span v-if="isFailed || isUndelivered" class="text-error"><i class="fas fa-exclamation"></i></span>
                <span v-if="!isGuestMessage && (isRead || isDelivered)" class="message__ticks" v-bind:class="{'message__ticks--read' : isRead}"><i class="fas fa-check"></i><i class="fas fa-check"></i></span>
                <span v-if="isSystemMessage" class="message__auto"><i class="fas fa-cogs"></i></span>
            </p>
        </div>
    <!--                                <div v-if="isGuestMessage(message)" class="w-10 message__translate"><i class="fas fa-language"></i></div>-->
    </div>
</template>

<script>

import { chatMessageMixin } from '../../mixins/ChatMessageMixin.js';
import { stringsMixin } from '../../mixins/StringsMixin.js';
import { datesMixin } from '../../mixins/DatesMixin.js';

export default {
    name: 'ChatMessage',
    components: {},
    mixins: [chatMessageMixin, stringsMixin, datesMixin],
    props: {
        message: {
            type: Object,
            default: () => ({})
        },
        unreadCountForDisplayInChat: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            // Local state variables
            isEditing: false,
            editText: this.text
        };
    },
    computed: {
        formattedTime() {
            // Stub for formatting timestamp
            return this.timestamp;
        },
    },
    methods: {
        getMediaFileName(url) {
            const baseUrl = url.split("?")[0];
            const filename = baseUrl.split("/").pop();
            console.log(filename);
            return filename;
        }
    },
    created() {
    },
    mounted() {
    }
};
</script>

<style lang="scss" scoped>
    @import "../../styles/pages/_chat.scss";
    @import "../../styles/components/_message.scss";
</style>